<template>
  <section>
    <b-row class="mt-2 request-header">
      <b-col lg="7" md="9" sm="12" xl="6">
        <b-form-group
          class="team-access-title"
          label="Manage Access for:"
          label-cols-lg="5"
          label-cols-md="5"
          label-cols-sm="5"
          label-cols-xl="4"
          label-for="teamMemberSelection"
        >
          <b-form-select
            id="teamMemberSelection"
            v-model="selectedUserId"
            :options="teamMembers"
            style="border: 2px solid #0095FF;border-radius: 24px;"
            text-field="fullName"
            value-field="personId"
            @input="updateSelectedUser"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <hr class="solid py-1" />
    <person-details></person-details>
  </section>
</template>

<script>
  import PersonDetails from '../PersonDetails';
  import { mapGetters } from 'vuex';

  export default {
    name: 'my-team-header',
    components: {
      PersonDetails,
    },
    props: {
      teamMembers: { type: Array, default: () => [] },
    },
    data() {
      return {
        selectedUserId: null,
      };
    },
    computed: {
      ...mapGetters(['userDetails']),
    },
    created() {
      this.selectedUserId = this.userDetails.personId;
    },
    methods: {
      getUser() {
        return this.teamMembers.find(el => el.personId === this.selectedUserId);
      },
      updateSelectedUser() {
        this.$store.commit('setUserDetails', this.getUser());
      },
    },
  };
</script>

<style scoped>
  .team-access-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
  }
</style>
